import type { WarehouseSync } from '@/services/db/warehouse-sync/entity';

/** What every connector landing page needs; the route view resolves all three. */
export type WarehouseLandingPageProps = {
  workspaceId: string;
  /** The workspace's sync, or `null` when none is configured. */
  sync: WarehouseSync | null;
  showPremiumLabel: boolean;
};

/** Which connector landing page a route is, so both sides of the handoff name the same one. */
export type WarehouseConnector = 'redshift' | 'bigquery' | 'snowflake';

/** The connector's product name, as its landing page titles it and analytics reports it. */
export const WAREHOUSE_CONNECTOR_NAMES = {
  redshift: 'Amazon Redshift',
  bigquery: 'Google BigQuery',
  snowflake: 'Snowflake',
} as const satisfies Record<WarehouseConnector, string>;

const WAREHOUSE_DESTINATIONS = ['s3', 'gcs', 'yandex', 'azure_blob'] as const;

/**
 * Resolve a `:type` route param to a real storage destination, or `null`.
 * Returns the value rather than asserting it: `find` over the literal tuple
 * narrows on its own, so no unchecked predicate is needed.
 */
export function toWarehouseDestination(value: string): (typeof WAREHOUSE_DESTINATIONS)[number] | null {
  return WAREHOUSE_DESTINATIONS.find((destination) => destination === value) ?? null;
}
